export const ValueType = {
    /**
     * @constant
     * @type {number}
     */
    NUMBER: 1,
    /**
     * @constant
     * @type {number}
     */
    BOOLEAN: 2,
    /**
     * @constant
     * @type {number}
     */
    BIG_NUM: 3
}